import {
  DropBoxItem,
  DropBoxOptionWrapper,
  DropBoxValue,
  DropBoxWrapper,
} from "./style";

export interface DropBoxProps {
  value: any;
  setValue: (v: any) => void;
  label: string;
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  option: any[];
}

const DropBox = ({
  value,
  setValue,
  label,
  setIsOpen,
  isOpen,
  option,
}: DropBoxProps) => {
  return (
    <DropBoxWrapper onClick={() => setIsOpen(!isOpen)}>
      <DropBoxValue>
        <div className="value">
          {value?.pubName ? value.pubName : value}
          {label}
        </div>
        <img src="/image-web/Icon/Arrow%20down.svg" alt="arrow" />
      </DropBoxValue>
      {isOpen && (
        <DropBoxOptionWrapper>
          {option.map((item, i) => (
            <DropBoxItem
              isSelected={item === value}
              key={i}
              onClick={() => setValue(item)}
            >
              <span> {item?.pubName ? item.pubName : item} </span>
              <span>{label}</span>
            </DropBoxItem>
          ))}
        </DropBoxOptionWrapper>
      )}
    </DropBoxWrapper>
  );
};

export default DropBox;
